import { PropsWithChildren } from 'react'

import { AptosWalletAdapterProvider } from '@aptos-labs/wallet-adapter-react'
import { BitgetWallet } from '@bitget-wallet/aptos-wallet-adapter'
import { MartianWallet } from '@martianwallet/aptos-wallet-adapter'
import { MSafeWalletAdapter } from '@msafe/aptos-wallet-adapter'
import { OKXWallet } from '@okwallet/aptos-wallet-adapter'
import { PontemWallet } from '@pontem/wallet-adapter-plugin'
import { DAPP_CONFIG } from 'config'

const wallets = [new PontemWallet(), new BitgetWallet(), new MartianWallet(), new MSafeWalletAdapter(), new OKXWallet()]

export const WalletProvider = ({ children }: PropsWithChildren) => {
  // const [key, setKey] = useState(0)

  const onError = (error: string) => {
    console.log('~ ~ onError ~ error:', error)
  }

  // useEffect(() => {
  //   if (window.pontem) {
  //     window.pontem.onAccountChange((account) => {
  //       console.log('~ ~ onAccountChange ~ account:', account)
  //       // do it only for disconnect
  //       // if (!account) setKey(new Date().getTime())
  //     })
  //   }
  // }, [])

  return (
    <AptosWalletAdapterProvider autoConnect dappConfig={DAPP_CONFIG} onError={onError} plugins={wallets}>
      {children}
    </AptosWalletAdapterProvider>
  )
}
